import { ProfileValueOption, ProfileFields } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig } from '../utils/fields.helpers';
import {
  mapStandardProfileArrayValues,
  mapStandardProfileSingleValue,
} from '../utils/resolvers.helpers';

export const FINANCIAL_FIELD_CONFIGS: Partial<FieldConfig> = {
  financialCredentials: createFieldConfig({
    key: 'financialCredentials',
    type: { variant: 'MULTIPLE_SELECT' },
    chipType: 'pill',
    placeholder: 'Select Financial Credentials',
  }),
  financialProfile: createFieldConfig({
    key: 'financialProfile',
    type: { variant: 'MULTIPLE_SELECT' },
    chipType: 'pill',
    placeholder: 'Select Financial Profiles',
  }),
  financialExperiences: createFieldConfig({
    key: 'financialExperiences',
    type: { variant: 'CHECKBOX_GROUP' },
  }),
  financialFamilyIncomes: createFieldConfig({
    key: 'financialFamilyIncomes',
    type: { variant: 'SINGLE_SELECT' },
    placeholder: 'Select Estimated Family Income',
  }),
};

export const FINANCIAL_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Finances',
  description: 'Add your financial history and portfolio.',
  sections: [
    {
      title: 'Estimated Family Income',
      keys: ['financialFamilyIncomes'],
      description:
        'Knowing your estimate helps you understand what you might actually pay for college after grants and scholarships.',
      infoModal: {
        title: 'Estimated Family Income',
        description:
          'To estimate your family income, ask your parents about their total yearly earnings before taxes—this matters because it affects the grants and scholarships you qualify for, which can significantly lower what you actually pay for college',
      },
    },
    {
      title: 'Financial Profile',
      keys: ['financialProfile'],
    },
    {
      title: 'Financial Credentials',
      keys: ['financialCredentials'],
    },
    {
      title: 'Financial Experiences',
      keys: ['financialExperiences'],
      description: 'Select all that apply to you.',
    },
  ],
};

export const FINANCIAL_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption>>
> = {
  financialFamilyIncomes: (profile, options) =>
    mapStandardProfileSingleValue(
      profile.profile.financialFamilyIncomes,
      options.financialFamilyIncomes,
    ),

  financialProfile: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.financialProfile, options.financialProfile),

  financialCredentials: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.financialCredentials,
      options.financialCredentials,
    ),

  financialExperiences: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.financialExperiences,
      options.financialExperiences,
    ),
};
